import type { VFC } from 'react'
import type { Theme } from '@opallabs/gem'
import { AvatarProps, ConnectedCurrentUserAvatar } from '@opallabs/kuiper'
import { CSVExportPopover } from './CSVExportPopover'

type UserTokenProps = {
  avatarOverrideProps?: Partial<AvatarProps>
  hasUnseenNotification?: boolean
  isExportPopoverOpen?: boolean
  onClick?: () => void
  onExportPopoverConfirm: () => void
  theme?: Theme
}

const UserToken: VFC<UserTokenProps> = ({
  avatarOverrideProps,
  hasUnseenNotification = false,
  isExportPopoverOpen = false,
  onClick,
  onExportPopoverConfirm,
  theme = 'light',
}) => {
  const Avatar = (
    <ConnectedCurrentUserAvatar
      onClick={onClick}
      size={32}
      unread={hasUnseenNotification}
      theme={theme}
      {...avatarOverrideProps}
    />
  )

  // Yes, this is a strange way to render a popover, but it's necessary
  // because we only want it to open when `isExportPopoverOpen` is true.
  // If we used the `open` prop, it could open from user interactions too
  if (isExportPopoverOpen) {
    return (
      <CSVExportPopover onExportPopoverConfirm={onExportPopoverConfirm}>
        {Avatar}
      </CSVExportPopover>
    )
  }

  return Avatar
}

export default UserToken
